import { lazy, Suspense } from "react";
import PageLoadFallback from "../components/PageLoadFallback";

/** Code-split a page module and wrap it in Suspense for React Router. */
export function lazyPage(importer) {
  const LazyComponent = lazy(importer);
  function LazyPageRoute(props) {
    return (
      <Suspense fallback={<PageLoadFallback />}>
        <LazyComponent {...props} />
      </Suspense>
    );
  }
  LazyPageRoute.displayName = "LazyPageRoute";
  return LazyPageRoute;
}
